module.exports = __webpack_public_path__ + "img/satellite.400.8bb8d271.png";